/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {listUserApiKeyExtensions} from '../api'

export const useMutationListUserApiKeyExtensions = createReactQueryMutationHook('listUserApiKeyExtensions', listUserApiKeyExtensions)
